module.exports = __webpack_public_path__ + "static/media/EditPicPencil.ba535bca.svg";